// src/components/img/GalerySectionVessels/VesselsafinPrize.tsx
import React from 'react';
import vesselImage from './safinPrize.jpeg';

const VesselsafinPrize: React.FC = () => (
  <img src={vesselImage} alt="Vessel safinPrize" />
);

export default VesselsafinPrize;